class Breadcrumb {
	constructor( node, opts = {} ) {
		this.node = node;
		this.opts = Object.assign( {
			togglerClass    : 'breadcrumb__mobile-toggle',
			openClass       : 'breadcrumb--open',
			itemTogglerClass: 'breadcrumb__toggler',
			itemClass       : 'breadcrumb__item',
			openItemClass   : 'breadcrumb__item--open',
		}, opts );
		this.openItem = null;

		this.onClick = this.onClick.bind( this );
		this.onBlur  = this.onBlur.bind( this );

		this.node.addEventListener( 'click', this.onClick );
		document.body.addEventListener( 'click', this.onBlur );
	}

	onClick( e ) {
		let node = e.target;

		while ( node && node !== this.node ) {
			if ( node.classList.contains( this.opts.togglerClass ) ) {
				this.node.classList.toggle( this.opts.openClass );
				return;
			}

			if ( node.classList.contains( this.opts.itemTogglerClass ) ) {
				let item = node.closest( `.${this.opts.itemClass}` );

				if ( item ) {
					if ( item.classList.contains( this.opts.openItemClass ) ) {
						item.classList.remove( this.opts.openItemClass );
						this.openItem = null;
					} else {
						if ( this.openItem ) {
							this.openItem.classList.remove( this.opts.openItemClass );
						}

						item.classList.add( this.opts.openItemClass );
						this.openItem = item;
					}
				}

				return;
			}

			node = node.parentNode;
		}
	}

	onBlur( e ) {
		if ( ! this.openItem ) {
			return;
		}

		let node = e.target;

		while( node && node.parentNode ) {
			if ( node === this.openItem ) {
				return;
			}

			node = node.parentNode;
		}

		this.openItem.classList.remove( this.opts.openItemClass );
	}
}

export default Breadcrumb;
